import React from "react";

export default (props) => (
  <footer className="section purple darken-3 white-text center">
    <p>Vidalink &copy; 2019</p>
  </footer>
);
